type PathParams = {
  [key: string]: number | string;
};

export const formatRoute = (path: string, params: PathParams) => {
  let result = path;
  Object.keys(params).forEach((k) => {
    const value = String(params[k]);
    result = result.split(`:${k}`).join(value);
  });

  return result;
};

export const MAX_SUBSCRIPTION_USER_PAGE =
  'https://globis4biz.zendesk.com/hc/ja/articles/360008520113';

export const ROLE_AND_INVITATION_PAGE =
  'https://globis4biz.zendesk.com/hc/ja/articles/360007167154-3';

// 管理者一覧画面の文言いろいろ
// https://github.com/globis-org/glopla-dev-portal/issues/981#issuecomment-527014104
export const MEMBERSHIP_HINT_PAGE_JA_1 =
  'https://globis4biz.zendesk.com/hc/ja/articles/360007167154';
export const MEMBERSHIP_HINT_PAGE_JA_2 =
  'https://globis4biz.zendesk.com/hc/ja/articles/360000251942';
export const MEMBERSHIP_HINT_PAGE_JA_3 =
  'https://globis4biz.zendesk.com/hc/ja/articles/360000252501';

export const pages = {
  activation: {
    start: '/activation/start', // 一人目の管理者登録
    alreadyCompleted: '/activation/already-completed',
    success: '/activation/success',
  },
  admin: {
    activate: '/admins/:adminId/activate/:token',
  },
  auth: {
    gateway: '/auth/gateway',
    openid: {
      callBack: '/auth/openid/callback',
    },
  },
  membership: {
    index: '/memberships',
    invite: '/membership/invite',
  },
  role: {
    list: '/roles',
  },
  signin: {
    index: '/signin',
  },
  signout: {
    index: '/signout',
  },
  password: {
    reset: {
      start: '/password/reset/start',
      success: '/password/reset/success',
      index: '/password/reset',
    },
  },
  account: {
    index: '/account',
    name: {
      edit: '/account/name/edit',
    },
    password: {
      edit: '/account/password/edit',
    },
  },
  subscription: {
    edit: '/subscription/:requestCode/edit/:step?',
    new: '/subscription/group/:serviceGroupId/new/:step?',
    detail: '/subscription/:requestCode',
  },
  service: {
    detail: '/services/:id',
  },
  project: {
    subscription: {
      edit: '/project/:projectCode/subscription/:requestCode/edit/:step?',
      new: '/project/:projectCode/subscription/:projectClassId/new',
    },
  },
  token: {
    expired: '/token/expired',
    sent: '/token/sent',
  },
  top: '/',
  users: {
    index: '/users',
  },
};
